// Misc
import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { updateCustomField } from 'utils/proposals'

// Atoms
import TextInput from 'atoms/TextInput'
import Spacer from 'atoms/Spacer'
import FieldLayout from '../FieldLayout'

export default class ProposalLinkEditor extends Component {
  static propTypes = {
    field: PropTypes.object.isRequired,
    normalizedFields: PropTypes.array.isRequired,
    onProposalUpdate: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
  }

  handleURLSave = (url) => {
    const { field, normalizedFields, onProposalUpdate } = this.props
    onProposalUpdate({
      data: {
        fields: updateCustomField(normalizedFields, field.key, { url })
      }
    })
  }

  handleLabelSave = (label) => {
    const { field, normalizedFields, onProposalUpdate } = this.props
    onProposalUpdate({
      data: {
        fields: updateCustomField(normalizedFields, field.key, { label })
      }
    })
  }

  handleDelete = () => {
    const { onDelete } = this.props
    onDelete()
  }

  render() {
    const { field } = this.props
    return (
      <Fragment>
        <Spacer />
        <FieldLayout title="Link" onDelete={this.handleDelete}>
          <TextInput
            required
            url
            maxLength={512}
            label="URL"
            placeholder="Add a website link here..."
            defaultValue={field.url || ''}
            onSave={this.handleURLSave}
          />
          <Spacer small />
          <TextInput
            maxLength={30}
            label="Title"
            placeholder="Add a link title (e.g. Event website, Purchase tickets, Learn more, etc.)"
            defaultValue={field.label || ''}
            onSave={this.handleLabelSave}
          />
        </FieldLayout>
      </Fragment>
    )
  }
}
